module.exports = __webpack_public_path__ + "img/active_promoter.e46192fd.png";